<template>
  <v-app>
    <v-main>
      <v-row>
        <v-col>
          <v-form class="ma-6 pa-0">
            <v-row>
              <v-col>
                <v-select
                  :items="users"
                  v-model="selectUser"
                  outlined
                  item-text="NAME"
                  item-value="ID"
                  label="Сотрудник"
                  :disabled="!isAdmin"
                >
                </v-select>
              </v-col>
              <v-col>
                <v-autocomplete
                  :items="deals"
                  v-model="selectDeal"
                  outlined
                  item-text="TITLE"
                  item-value="ID"
                  label="Заявка"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-space-between">
              <v-col>
                <v-btn
                  color="success"
                  class="mr-4"
                  @click="getReport"
                  text
                  :disabled="loading"
                >
                  Сформировать
                </v-btn>
              </v-col>
              <v-col
                ><b
                  >Итого к выплате:
                  {{ new Intl.NumberFormat("ru-RU").format(totalPays) }}р.</b
                ></v-col
              >
            </v-row>
          </v-form>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            :loading="loading"
            dense
            disable-sort
            :headers="headers"
            :items="reportItems"
            hide-default-footer
            :items-per-page="100000"
            class="elevation-1"
            group-by="name"
          >
            <template v-slot:[`progress`]>
              <v-progress-linear v-model="loadingValue" height="10">
                <strong>{{ Math.ceil(loadingValue) }}%</strong>
              </v-progress-linear>
            </template>
            <template v-slot:[`group.header`]="{ items, isOpen, toggle }">
              <th colspan="6">
                <v-icon @click="toggle"
                  >{{ isOpen ? "mdi-minus" : "mdi-plus" }}
                </v-icon>
                {{ items[0].name }}
              </th>
              <th>
                {{
                  new Intl.NumberFormat("ru-RU").format(
                    items
                      .reduce(function (acc, item) {
                        return Number(acc) + Number(item.sumXls);
                      }, 0)
                      .toFixed(2)
                  )
                }}
              </th>
              <th>
                {{
                  new Intl.NumberFormat("ru-RU").format(
                    items
                      .reduce(function (acc, item) {
                        return Number(acc) + Number(item.rewardUserXls);
                      }, 0)
                      .toFixed(2)
                  )
                }}
              </th>
              <th colspan="1"></th>
              <th>
                {{
                  new Intl.NumberFormat("ru-RU").format(
                    items
                      .reduce(function (acc, item) {
                        return Number(acc) + Number(item.rewardAutorXls);
                      }, 0)
                      .toFixed(2)
                  )
                }}
              </th>
              <th colspan="1"></th>
              <th>
                {{
                  new Intl.NumberFormat("ru-RU").format(
                    items
                      .reduce(function (acc, item) {
                        return Number(acc) + Number(item.totalXls);
                      }, 0)
                      .toFixed(2)
                  )
                }}
              </th>
              <!--<th>
                {{
                  !items[0].isComission
                    ? new Intl.NumberFormat("ru-RU").format(
                        (
                          items.reduce(function (acc, item) {
                            return Number(acc) + Number(item.totalXls);
                          }, 0) *
                            0.01 +
                          59
                        ).toFixed(2)
                      )
                    : ""
                }}
              </th>-->
              <th>0</th>
              <th>
                {{
                  new Intl.NumberFormat("ru-RU").format(
                    Math.round(
                      Number(
                        items.reduce(function (acc, item) {
                          return Number(acc) + Number(item.totalXls);
                        }, 0)
                      ).toFixed(2)
                    )
                  )
                }}
              </th>
              <th>
                <v-btn @click="exportXls(items)" text :disabled="payLoading">
                  <v-icon>mdi-file-document-refresh-outline</v-icon>
                </v-btn>
                <v-btn
                  @click="paysAdd(items)"
                  text
                  :disabled="payLoading || !isPayUser"
                >
                  <v-icon>mdi-cash-sync</v-icon>
                </v-btn>
              </th>
              <th>
                <v-checkbox
                  v-model="items[0].check"
                  @change="changeCheck(items[0].check, items)"
                ></v-checkbox>
              </th>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import exeljs from "exceljs";
import fileWrite from "file-saver";
import { BX24 } from "bx24";

export default {
  name: "App",
  data: () => ({
    loadingValue: 0,
    isAdmin: false,
    loading: false,
    payLoading: false,
    auth: null,
    isPayUser: false,
    normalDate: [],
    users: [],
    userID: "",
    selectUser: "",
    selectDeal: "",
    deals: [],
    items: [],
    reportItems: [],
    paysList: [],
    headers: [
      {
        text: "№",
        align: "start",
        sortable: true,
        value: "number",
      },
      {
        text: "Заявка",
        align: "start",
        sortable: true,
        value: "deal",
      },
      {
        text: "ИТОГО сумма по услуге",
        align: "start",
        sortable: true,
        value: "sumToDealXls",
      },
      {
        text: "Дата действия",
        align: "start",
        sortable: true,
        value: "date",
      },
      {
        text: "Услуга",
        align: "start",
        sortable: true,
        value: "comment",
      },
      {
        text: "Кол-во шт / ч / кв. м / пог.м",
        align: "start",
        sortable: true,
        value: "hours",
      },
      {
        text: "Сумма выручки за проведенные консультации",
        align: "start",
        sortable: false,
        value: "sum",
      },
      {
        text: "Вознаграждение Исполнителя за Услуги по Договору",
        align: "start",
        sortable: false,
        value: "rewardUser",
      },
      {
        text: "Наименование РИД, созданное Исполнителем по Договору",
        align: "start",
        sortable: true,
        value: "rid",
      },
      {
        text: "Авторское вознаграждение Исполнителя за РИД",
        align: "start",
        sortable: false,
        value: "rewardAutor",
      },
      {
        text: "Дата отчета",
        align: "start",
        sortable: true,
        value: "dateReport",
      },
      {
        text: "ФИО Исполнителя",
        align: "start",
        sortable: true,
        value: "name",
      },
      {
        text: "ИТОГО",
        align: "start",
        sortable: false,
        value: "total",
      },
      {
        text: "Комиссия за перевод с ИП физ.лицу 1% + 59руб.",
        align: "start",
        sortable: false,
        value: "comission1",
      },
      {
        text: "ИТОГО к оплате:",
        align: "start",
        sortable: false,
        value: "totalInPayXls1",
      },
      {
        text: "Действие",
        align: "start",
        sortable: false,
        value: "action",
      },
      {
        text: "",
        align: "start",
        sortable: false,
        value: "isCheck",
      },
    ],
    ridType: {
      214: "Фото/видеоматериалы",
      216: "Фото/видеоматериалы",
      218: "Фото/видеоматериалы",
      220: "Фото/видеоматериалы",
      222: "Фото/видеоматериалы",
      224: "Фото/видеоматериалы",
      422: "Презентация",
      424: "Презентация",
      458: "Фото/видеоматериалы",
      460: "Фото/видеоматериалы",
      462: "Фото/видеоматериалы",
      464: "Фото/видеоматериалы",
      466: "Фото/видеоматериалы",
      468: "Презентация",
      470: "Презентация",
      472: "Презентация",
      474: "Презентация",
      476: "Фото/видеоматериалы",
      478: "Фото/видеоматериалы",
      480: "Фото/видеоматериалы",
      482: "Фото/видеоматериалы",
      484: "Презентация",
      486: "Фото/видеоматериалы",
      488: "Фото/видеоматериалы",
      490: "Фото/видеоматериалы",
      492: "Фото/видеоматериалы",
      494: "Фото/видеоматериалы",
      562: "Фото/видеоматериалы",
      496: "Фото/видеоматериалы",
    },
    totalPays: 0,
    typeComissionAgency: {
      388: 0,
      390: 0.2,
      392: 0.3,
      850: 0.024,
      394: "base",
      396: 1,
      880: 0.08,
    },
    typeActions: {},
    propertyComments: {},
    url: "https://proporyadok.bitrix24.ru/rest/2/7c7l5pw7xlblpdgg/",
    authUrl: "",
  }),
  methods: {
    pause(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async changeCheck(isTrue, items) {
      try {
        for (const item of items) {
          await axios.post(this.url + "bizproc.workflow.start", {
            TEMPLATE_ID: 308,
            DOCUMENT_ID: [
              "lists",
              "Bitrix\\Lists\\BizprocDocumentLists",
              item.number,
            ],
            PARAMETERS: {
              isTrue: isTrue ? "Y" : "N",
            },
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    async paysAdd(items) {
      try {
        const isTrue = confirm("Вы уверены что хотите оплатить?");
        if (isTrue) {
          let id = "";
          this.payLoading = true;
          const itemIDs = [];
          const itemsToPys = [];
          let sum = 0;
          const manager = items[0].managerID;
          for (const item of items) {
            console.log({ item });
            await axios.post(this.url + "lists.element.add", {
              IBLOCK_TYPE_ID: "lists",
              IBLOCK_ID: "56",
              ELEMENT_CODE: `${item.number}/${item.managerID}/${
                item.totalXls
              }/${new Date()}`,
              FIELDS: {
                NAME: "Выплаты",
                PROPERTY_514: item.managerID,
                PROPERTY_522: new Date().toLocaleDateString("ru-RU"),
                PROPERTY_524: item.number,
                PROPERTY_518: item.dealID,
                PROPERTY_520: item.product,
                PROPERTY_526: item.totalXls,
                PROPERTY_550: item.date,
              },
            });

            itemIDs.push(item.number);
            itemsToPys.push(item.number);
            const index = this.items.findIndex((e) => e.id == item.id);
            this.items.splice(index, 1);
          }
          const period = items[0].period;
          sum = Math.round(
            Number(
              items.reduce(function (acc, item) {
                return Number(acc) + Number(item.totalXls);
              }, 0)
            ).toFixed(2)
          );

          const needPays = this.paysList.filter((e) => e.manager == manager);
          console.log({ needPays });
          if (needPays.length > 0) {
            if (needPays[0].pays.length > 0) {
              itemIDs.push(...needPays[0].pays);
            }
            //console.log({ itemIDs });
            //console.log({ manager });
            const elem = await axios.post(this.url + "lists.element.get", {
              IBLOCK_TYPE_ID: "lists",
              IBLOCK_ID: "52",
              FILTER: {
                PROPERTY_454: manager,
              },
            });
            //console.log({ elem });
            id = elem.data.result[0].ID;

            const params = {
              IBLOCK_TYPE_ID: "lists",
              IBLOCK_ID: "52",
              ELEMENT_ID: id,
              FIELDS: {
                NAME: "pays",
                PROPERTY_454: manager,
                PROPERTY_456: itemIDs,
                PROPERTY_458: needPays[0].cheks,
              },
            };
            //console.log({ params });
            await axios.post(this.url + "lists.element.update", params);
          } else {
            const params = {
              IBLOCK_TYPE_ID: "lists",
              IBLOCK_ID: "52",
              ELEMENT_CODE: manager,
              FIELDS: {
                NAME: "pays",
                PROPERTY_454: manager,
                PROPERTY_456: itemIDs,
                PROPERTY_458: [],
              },
            };
            const resultAdd = await axios.post(
              this.url + "lists.element.add",
              params
            );
            id = resultAdd.data.result;
          }

          const bizprocIDAdd = await axios.post(
            this.url + "lists.element.add",
            {
              IBLOCK_TYPE_ID: "bitrix_processes",
              IBLOCK_ID: "54",
              ELEMENT_CODE: `${manager}-${itemsToPys}-${sum} ${new Date()}`,
              FIELDS: {
                NAME: "app",
                PROPERTY_492: manager,
                //PROPERTY_490: `${sum}|RUB`,
              },
            }
          );
          const bizprocID = bizprocIDAdd.data.result;
          await axios.post(this.url + "bizproc.workflow.start", {
            TEMPLATE_ID: 432,
            DOCUMENT_ID: ["lists", "BizprocDocument", bizprocID],
            PARAMETERS: {
              sum,
              ids: itemsToPys,
              period,
            },
          });

          for (const itemID of itemsToPys) {
            await axios.post(this.url + "bizproc.workflow.start", {
              TEMPLATE_ID: 302,
              DOCUMENT_ID: [
                "lists",
                "Bitrix\\Lists\\BizprocDocumentLists",
                itemID,
              ],
              PARAMETERS: {},
            });
          }

          this.payLoading = false;
        }
      } catch (error) {
        console.log({ error });
      }
    },
    async getPays() {
      try {
        this.paysList = [];
        let start = 0;
        let isTrue = false;
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "52",
          start: start,
        };

        while (!isTrue) {
          const result = await axios.post(
            this.url + "lists.element.get",
            params
          );
          for (const item of result.data.result) {
            this.paysList.push({
              id: item.ID,
              manager: item.PROPERTY_454
                ? Object.values(item.PROPERTY_454)[0]
                : "",
              pays: item.PROPERTY_456 ? Object.values(item.PROPERTY_456) : [],
              cheks: item.PROPERTY_458 ? item.PROPERTY_458 : [],
            });
          }
          if (result.data.next) start = result.data.next;
          else isTrue = true;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getReport() {
      console.log("get report");
      await this.getPays();
      this.items = [];
      this.reportItems = [];
      const propertyValue = (elem) => (elem ? Object.values(elem)[0] : "");

      const reportLists = [];
      //---------------------
      const params = {
        IBLOCK_TYPE_ID: "lists",
        IBLOCK_ID: "36",
        FILTER: {
          PROPERTY_284: 210,
          "!PROPERTY_466": 812,
        },
      };
      if (this.selectUser) {
        params.FILTER["PROPERTY_286"] = this.selectUser;
      }
      if (this.selectDeal) {
        params.FILTER["PROPERTY_308"] = `D_${this.selectDeal}`;
      }
      const reportListsData = await axios.post(
        this.url + "lists.element.get",
        params
      );
      const total = reportListsData.data.total;
      const batchParams = {
        halt: 0,
        cmd: {},
      };
      let index = 0;
      for (let start = 0; start <= total + 49; start += 50) {
        batchParams.cmd[
          `${index}`
        ] = `lists.element.get?IBLOCK_TYPE_ID=lists&IBLOCK_ID=36&FILTER[PROPERTY_284]=210&FILTER[!PROPERTY_466]=812${
          this.selectUser ? `&FILTER[PROPERTY_286]=${this.selectUser}` : ""
        }${
          this.selectDeal ? `&FILTER[PROPERTY_308]=D_${this.selectDeal}` : ""
        }&start=${start}`;

        if (index > 49 || start <= total) {
          const batchResult = await axios.post(this.url + "batch", batchParams);
          for (const value of batchResult.data.result.result) {
            for (const itemValue of value) {
              const itemIndex = reportLists.findIndex(
                (e) => e.ID == itemValue.ID
              );
              if (itemIndex == -1) {
                console.log({ value });
                reportLists.push(...value);
              }
            }
          }
        }
      }
      const valAdd = (reportLists.length * 100) / 60 / 100; // 2.68 == 1%
      let valIndex = 0;
      for (const elem of reportLists) {
        valIndex += 1;
        await this.pause(200);
        if (valIndex > valAdd) {
          this.loadingValue += 1;
          valIndex = 0;
        }
        let period = ""; //PROPERTY_368
        //определяем день недели по дате(число)
        const elemDate = propertyValue(elem.PROPERTY_348);
        const date = new Date(
          `${elemDate.split(".")[2]}-${elemDate.split(".")[1]}-${
            elemDate.split(".")[0]
          }`
        );
        const dayWeek = date.getDay();
        //определяем первый день недели
        if (Number(dayWeek) > 0) {
          date.setDate(date.getDate() - (Number(dayWeek) - 1));
          period = `${date.toLocaleDateString("ru-RU")} - `;
          date.setDate(date.getDate() + 6);
          period += date.toLocaleDateString("ru-RU");
        } else {
          date.setDate(date.getDate() - 6);
          period = `${date.toLocaleDateString("ru-RU")} - `;
          date.setDate(date.getDate() + 6);
          period += date.toLocaleDateString("ru-RU");
        }
        const items = [];
        let indexSenior = "";
        const usersIDs = Object.values(elem.PROPERTY_286);
        const sumToDeal = Number(
          propertyValue(elem.PROPERTY_278).split("|")[0]
        );
        const comissionAgencyData =
          this.typeComissionAgency[propertyValue(elem.PROPERTY_346)];
        const countToDeal = Number(propertyValue(elem.PROPERTY_468));
        let hasManager = false;
        const typeAction = propertyValue(elem.PROPERTY_356);
        if (typeAction == 454) hasManager = true;

        if (
          !propertyValue(elem.PROPERTY_308).split("_")[0].includes("Tb8") &&
          elem.PROPERTY_308
        ) {
          const dealData = await axios.post(this.url + "crm.deal.get", {
            id: propertyValue(elem.PROPERTY_308).split("_")[1],
          });
          //прорабатываем вопрос с агентом
          const agent = dealData.data.result.UF_CRM_1727668545; //агент указанный в сделке
          if (agent) {
            console.log({ agent });
            //если агент есть, добавляем итем с указанием id агента
            const sumAgent = Number(sumToDeal) * 0.05;
            const item = {
              check: elem.PROPERTY_484 ? true : false,
              id: `agent-${agent}/${elem.ID}`,
              number: elem.ID,
              hours: "",
              name: this.users.filter((e) => e.ID == agent)[0].NAME,
              managerID: agent,
              sumToDealXls: new Intl.NumberFormat("ru-RU").format(
                sumToDeal.toFixed(2)
              ),
              sumToDeal,
              product: "Бонус",
              period: period,
              deal: dealData.data.result.TITLE,
              dealID: dealData.data.result.ID,
              rid: this.ridType[propertyValue(elem.PROPERTY_288)],
              sum: "", //new Intl.NumberFormat("ru-RU").format(sumToDeal.toFixed(2)),
              sumXls: "", //sumToDeal,
              date: elem.PROPERTY_348 ? propertyValue(elem.PROPERTY_348) : "",
              dateReport: elem.PROPERTY_368
                ? propertyValue(elem.PROPERTY_368)
                : "",
              comment: "Бонус",
              typeAction: typeAction ? this.typeActions[typeAction] : "",
              rewardAutor: "",
              rewardAutorXls: "",
              rewardUser: new Intl.NumberFormat("ru-RU").format(
                Number(sumAgent.toFixed(2))
              ),
              rewardUserXls: sumAgent,
              total: new Intl.NumberFormat("ru-RU").format(sumAgent.toFixed(2)),
              totalXls: sumAgent,
              comission: "",
              comissionXls: "",
              totalInPay: new Intl.NumberFormat("ru-RU").format(
                sumAgent.toFixed(2)
              ),
              isComission: false,
              totalInPayXls: sumAgent,
              action: "",
            };
            this.items.push(item);
            console.log("agent ok");
          }

          //ID старшего ОП
          const seniorOPID = dealData.data.result.UF_CRM_1690220119;
          //рассчет зарплат
          //определяем тип
          const typeSalary = propertyValue(elem.PROPERTY_464);
          const bonusOP =
            (propertyValue(elem.PROPERTY_504) == "852" &&
              propertyValue(elem.PROPERTY_462) != "Комплектация" &&
              propertyValue(elem.PROPERTY_462) != "Выезд за МКАД") ||
            (propertyValue(elem.PROPERTY_504) == "" &&
              propertyValue(elem.PROPERTY_462) != "Комплектация" &&
              propertyValue(elem.PROPERTY_462) != "Выезд за МКАД")
              ? "Y"
              : "N"; // bonus OP

          if (typeSalary == "804" && !hasManager) {
            //колличественный расчет(с указанием часов или разделением на равные доли)
            const price = sumToDeal / countToDeal; //58 500/9 = 6500
            const countItems = elem.PROPERTY_290
              ? Object.values(elem.PROPERTY_290)
              : "";

            let sumToOP = 0;
            let sumToOpUser = 0;
            let comissionAgencySum = 0;
            for (const userIndex in usersIDs) {
              console.log(usersIDs[userIndex]);
              const userRate = this.users.filter(
                (e) => e.ID == usersIDs[userIndex]
              )[0].rate;
              const comissionAgency =
                comissionAgencyData == "base"
                  ? userRate
                    ? Number(userRate)
                    : 0.6
                  : comissionAgencyData;
              //расчет сумм
              let sum = 0;
              if (usersIDs[userIndex] == seniorOPID) {
                indexSenior = userIndex;
                //старший ОП
                sum = countItems
                  ? Number(price) * Number(countItems[userIndex])
                  : sumToDeal / usersIDs.length;
              } else {
                sum = countItems
                  ? Number(price) * Number(countItems[userIndex])
                  : sumToDeal / usersIDs.length;
                if (bonusOP == "Y") {
                  comissionAgencySum = Number(sum) * Number(comissionAgency);
                  sumToOP += (Number(sum) - Number(comissionAgencySum)) * 0.1;
                  sumToOpUser =
                    Number(comissionAgency) < 0.6
                      ? (Number(sum) - Number(comissionAgencySum)) * 0.1
                      : 0;
                }
              }
              comissionAgencySum = Number(sum) * Number(comissionAgency);

              const rewardAutor =
                comissionAgency != 0
                  ? comissionAgency != 1
                    ? comissionAgency != 0.024
                      ? (Number(sum) -
                          Number(comissionAgencySum) -
                          Number(sumToOpUser)) *
                        0.05
                      : 0
                    : 0
                  : 0;

              const rewardUser =
                Number(sum) -
                Number(comissionAgencySum) -
                Number(sumToOpUser) -
                Number(rewardAutor);

              const total = Number(rewardAutor) + Number(rewardUser);
              const comission = 0; //Number(total) * 0.01 + 59;
              const totalInPayXls = Number(total) - Number(comission);

              const item = {
                check: elem.PROPERTY_484 ? true : false,
                id: `${usersIDs[userIndex]}/${elem.ID}`,
                number: elem.ID,
                hours: countItems[userIndex],
                name: this.users.filter((e) => e.ID == usersIDs[userIndex])[0]
                  .NAME,
                managerID: usersIDs[userIndex],
                sumToDealXls: new Intl.NumberFormat("ru-RU").format(
                  sumToDeal.toFixed(2)
                ),
                sumToDeal,
                product: propertyValue(elem.PROPERTY_462),
                period: period,
                deal: dealData.data.result.TITLE,
                dealID: dealData.data.result.ID,
                rid: this.ridType[propertyValue(elem.PROPERTY_288)],
                sum: new Intl.NumberFormat("ru-RU").format(sum.toFixed(2)),
                sumXls: sum,
                date: elem.PROPERTY_348 ? propertyValue(elem.PROPERTY_348) : "",
                dateReport: elem.PROPERTY_368
                  ? propertyValue(elem.PROPERTY_368)
                  : "",
                comment: elem.PROPERTY_288
                  ? this.propertyComments[propertyValue(elem.PROPERTY_288)]
                  : "",
                typeAction: typeAction ? this.typeActions[typeAction] : "",
                rewardAutor: new Intl.NumberFormat("ru-RU").format(
                  Number(rewardAutor.toFixed(2))
                ),
                rewardAutorXls: rewardAutor,
                rewardUser: new Intl.NumberFormat("ru-RU").format(
                  Number(rewardUser.toFixed(2))
                ),
                rewardUserXls: rewardUser,
                total: new Intl.NumberFormat("ru-RU").format(total.toFixed(2)),
                totalXls: total,
                comission: new Intl.NumberFormat("ru-RU").format(
                  comission.toFixed(2)
                ),
                comissionXls: comission,
                totalInPay: new Intl.NumberFormat("ru-RU").format(
                  totalInPayXls.toFixed(2)
                ),
                isComission: this.users.filter(
                  (e) => e.ID == usersIDs[userIndex]
                )[0].isIP
                  ? true
                  : false,
                totalInPayXls: totalInPayXls,
                action: "",
              };
              items.push(item);
            }
            if (indexSenior) {
              const userRate = this.users.filter(
                (e) => e.ID == usersIDs[indexSenior]
              )[0].rate;
              const comissionAgency =
                comissionAgencyData == "base"
                  ? userRate
                    ? Number(userRate) // + 0.05
                    : 0.6
                  : comissionAgencyData;

              comissionAgencySum =
                Number(items[indexSenior].sumXls) * Number(comissionAgency);
              items[indexSenior].sum = new Intl.NumberFormat("ru-RU").format(
                items[indexSenior].sumXls.toFixed(2)
              );
              //
              items[indexSenior].rewardAutorXls =
                comissionAgency != 0
                  ? comissionAgency != 1
                    ? comissionAgency != 0.024
                      ? Number(
                          items[indexSenior].sumXls - Number(comissionAgencySum)
                        ) * 0.05
                      : 0
                    : 0
                  : 0;
              items[indexSenior].rewardAutor = new Intl.NumberFormat(
                "ru-RU"
              ).format(items[indexSenior].rewardAutorXls.toFixed(2));
              //
              items[indexSenior].rewardUserXls = Number(
                Number(items[indexSenior].sumXls) -
                  Number(comissionAgencySum) -
                  Number(items[indexSenior].rewardAutorXls) +
                  Number(sumToOP)
              );
              items[indexSenior].rewardUser = new Intl.NumberFormat(
                "ru-RU"
              ).format(items[indexSenior].rewardUserXls.toFixed(2));
              //
              items[indexSenior].totalXls =
                Number(items[indexSenior].rewardAutorXls) +
                Number(items[indexSenior].rewardUserXls);
              items[indexSenior].total = new Intl.NumberFormat("ru-RU").format(
                items[indexSenior].totalXls.toFixed(2)
              );
              items[indexSenior].totalInPayXls = items[indexSenior].totalXls; //- items[indexSenior].comissionXls;
              items[indexSenior].totalInPay = new Intl.NumberFormat(
                "ru-RU"
              ).format(items[indexSenior].totalInPayXls.toFixed(2));
            }
            for (const item of items) {
              let managerPayed = -1;

              const managerPayedIndex = this.paysList.findIndex(
                (e) => e.manager == item.managerID
              );
              if (managerPayedIndex > -1) {
                managerPayed = this.paysList[managerPayedIndex].pays.findIndex(
                  (e) => e == item.number
                );
              }
              if (managerPayed < 0) {
                this.items.push(item);
              }
            }
          } else if (typeSalary == "806" && !hasManager) {
            //расчет по коэффициенту
            const price = sumToDeal; //итого сумма
            //PROPERTY_290 - коэфф каждого ОП
            const countItems = elem.PROPERTY_290
              ? Object.values(elem.PROPERTY_290)
              : "";

            let sumToOP = 0;
            let sumToOpUser = 0;
            let comissionAgencySum = 0;
            //перебираем каждого ОП
            for (const userIndex in usersIDs) {
              const userRate = this.users.filter(
                (e) => e.ID == usersIDs[userIndex]
              )[0].rate;

              const comissionAgency =
                comissionAgencyData == "base"
                  ? userRate
                    ? Number(userRate)
                    : 0.6
                  : comissionAgencyData;

              //расчет сумм
              let sum = 0;
              if (usersIDs[userIndex] == seniorOPID) {
                indexSenior = userIndex;
                //старший ОП
                sum = countItems
                  ? Number(price) * Number(countItems[userIndex])
                  : sumToDeal / usersIDs.length;
              } else {
                sum = countItems
                  ? Number(price) * Number(countItems[userIndex])
                  : sumToDeal / usersIDs.length;
                if (bonusOP == "Y") {
                  comissionAgencySum = Number(sum) * Number(comissionAgency);
                  sumToOP += (Number(sum) - Number(comissionAgencySum)) * 0.1;
                  sumToOpUser =
                    Number(comissionAgency) < 0.6
                      ? (Number(sum) - Number(comissionAgencySum)) * 0.1
                      : 0;
                }
              }
              comissionAgencySum = Number(sum) * Number(comissionAgency);

              console.log({ sum });
              console.log({ comissionAgencySum });
              console.log({ sumToOpUser });

              const rewardAutor =
                comissionAgency != 0
                  ? comissionAgency != 1
                    ? comissionAgency != 0.024
                      ? Number(sum * 0.05)
                      : 0
                    : 0
                  : 0;

              console.log({ rewardAutor });

              const rewardUser =
                Number(sum) -
                Number(comissionAgencySum) -
                Number(sumToOpUser) -
                Number(rewardAutor);
              const total = rewardAutor + rewardUser;
              const comission = 0;
              const totalInPay = total - comission;

              const item = {
                id: `${usersIDs[userIndex]}/${elem.ID}`,
                check: elem.PROPERTY_484 ? true : false,
                number: elem.ID,
                hours: countItems[userIndex],
                name: this.users.filter((e) => e.ID == usersIDs[userIndex])[0]
                  .NAME,
                period: period,
                managerID: usersIDs[userIndex],
                deal: dealData.data.result.TITLE,
                dealID: dealData.data.result.ID,
                product: propertyValue(elem.PROPERTY_462),
                sumToDeal,
                sumToDealXls: new Intl.NumberFormat("ru-RU").format(
                  Number(sumToDeal.toFixed(2))
                ),
                rid: this.ridType[propertyValue(elem.PROPERTY_288)],
                sum: new Intl.NumberFormat("ru-RU").format(sum.toFixed(2)),
                sumXls: sum,
                date: elem.PROPERTY_348 ? propertyValue(elem.PROPERTY_348) : "",
                dateReport: elem.PROPERTY_368
                  ? propertyValue(elem.PROPERTY_368)
                  : "",
                comment: elem.PROPERTY_288
                  ? this.propertyComments[propertyValue(elem.PROPERTY_288)]
                  : "",
                typeAction: typeAction ? this.typeActions[typeAction] : "",
                rewardAutor: new Intl.NumberFormat("ru-RU").format(
                  Number(rewardAutor.toFixed(2))
                ),
                rewardAutorXls: rewardAutor,
                rewardUser: new Intl.NumberFormat("ru-RU").format(
                  Number(rewardUser.toFixed(2))
                ),
                rewardUserXls: rewardUser,
                total: new Intl.NumberFormat("ru-RU").format(total.toFixed(2)),
                totalXls: total,
                comission: new Intl.NumberFormat("ru-RU").format(
                  comission.toFixed(2)
                ),
                comissionXls: comission,
                isComission: this.users.filter(
                  (e) => e.ID == usersIDs[userIndex]
                )[0].isIP
                  ? true
                  : false,
                totalInPay: new Intl.NumberFormat("ru-RU").format(
                  totalInPay.toFixed(2)
                ),
                totalInPayXls: totalInPay,
                action: "",
              };
              items.push(item);
            }
            if (indexSenior) {
              const userRate = this.users.filter(
                (e) => e.ID == usersIDs[indexSenior]
              )[0].rate;

              const comissionAgency =
                comissionAgencyData == "base"
                  ? userRate
                    ? Number(userRate)
                    : 0.6
                  : comissionAgencyData;
              comissionAgencySum =
                Number(items[indexSenior].sumXls) * Number(comissionAgency);
              items[indexSenior].sum = new Intl.NumberFormat("ru-RU").format(
                items[indexSenior].sumXls.toFixed(2)
              );
              items[indexSenior].rewardAutorXls =
                comissionAgency != 0
                  ? comissionAgency != 1
                    ? comissionAgency != 0.024
                      ? Number(items[indexSenior].sumXls * 0.05)
                      : 0
                    : 0
                  : 0;
              items[indexSenior].rewardAutor = new Intl.NumberFormat(
                "ru-RU"
              ).format(items[indexSenior].rewardAutorXls.toFixed(2));
              //
              items[indexSenior].rewardUserXls = Number(
                Number(items[indexSenior].sumXls) -
                  Number(comissionAgencySum) -
                  Number(items[indexSenior].rewardAutorXls) +
                  Number(sumToOP)
              );
              items[indexSenior].rewardUser = new Intl.NumberFormat(
                "ru-RU"
              ).format(items[indexSenior].rewardUserXls.toFixed(2));
              //
              items[indexSenior].totalXls =
                items[indexSenior].rewardAutorXls +
                items[indexSenior].rewardUserXls;
              items[indexSenior].total = new Intl.NumberFormat("ru-RU").format(
                items[indexSenior].totalXls.toFixed(2)
              );
              //
              items[indexSenior].comissionXls =
                items[indexSenior].total * 0.01 + 59;

              items[indexSenior].totalInPayXls =
                items[indexSenior].total - items[indexSenior].comission;
            }
            for (const item of items) {
              let managerPayed = -1;
              const managerPayedIndex = this.paysList.findIndex(
                (e) => e.manager == item.managerID
              );
              if (managerPayedIndex > -1) {
                managerPayed = this.paysList[managerPayedIndex].pays.findIndex(
                  (e) => e == item.number
                );
              }
              if (managerPayed < 0) {
                this.items.push(item);
              }
            }
          } else if (typeSalary == "808" && !hasManager) {
            //ручной
            const price = sumToDeal; //итого сумма
            //перебираем каждого ОП
            for (const userIndex in usersIDs) {
              const sum = Number(price);
              const total = sum;
              const comission = 0;
              const totalInPay = total - comission;

              const item = {
                id: `${usersIDs[userIndex]}/${elem.ID}`,
                check: elem.PROPERTY_484 ? true : false,
                number: elem.ID,
                hours: "",
                name: this.users.filter((e) => e.ID == usersIDs[userIndex])[0]
                  .NAME,
                period: period,
                managerID: usersIDs[userIndex],
                deal: dealData.data.result.TITLE,
                dealID: dealData.data.result.ID,
                product: propertyValue(elem.PROPERTY_462),
                sumToDeal,
                rid: "Презентация",
                sum: new Intl.NumberFormat("ru-RU").format(sum.toFixed(2)),
                sumXls: sum,
                date: elem.PROPERTY_348 ? propertyValue(elem.PROPERTY_348) : "",
                dateReport: elem.PROPERTY_368
                  ? propertyValue(elem.PROPERTY_368)
                  : "",
                comment: elem.PROPERTY_288
                  ? this.propertyComments[propertyValue(elem.PROPERTY_288)]
                  : "",
                typeAction: typeAction ? this.typeActions[typeAction] : "",
                rewardUser: new Intl.NumberFormat("ru-RU").format(
                  (Number(sum) * 0.95).toFixed(2)
                ),
                rewardUserXls: Number(sum) * 0.95,
                rewardAutor: new Intl.NumberFormat("ru-RU").format(
                  (Number(sum) * 0.05).toFixed(2)
                ),
                rewardAutorXls: Number(sum) * 0.05,
                total: new Intl.NumberFormat("ru-RU").format(total.toFixed(2)),
                totalXls: total,
                comission: new Intl.NumberFormat("ru-RU").format(
                  comission.toFixed(2)
                ),
                comissionXls: comission,
                isComission: this.users.filter(
                  (e) => e.ID == usersIDs[userIndex]
                )[0].isIP
                  ? true
                  : false,
                totalInPay: new Intl.NumberFormat("ru-RU").format(
                  totalInPay.toFixed(2)
                ),
                totalInPayXls: totalInPay,
                action: "",
              };
              const items = [item];
              for (const item of items) {
                let managerPayed = -1;
                const managerPayedIndex = this.paysList.findIndex(
                  (e) => e.manager == item.managerID
                );
                if (managerPayedIndex > -1) {
                  managerPayed = this.paysList[
                    managerPayedIndex
                  ].pays.findIndex((e) => e == item.number);
                }
                if (managerPayed < 0) {
                  this.items.push(item);
                }
              }
            }
          } else if (typeSalary == "842" && !hasManager) {
            //расчет по коэффициенту
            console.log("интернет-магазин!");
            const price = sumToDeal; //итого сумма
            //PROPERTY_290 - коэфф каждого ОП
            const countItems = elem.PROPERTY_290
              ? Object.values(elem.PROPERTY_290)
              : "";
            //перебираем каждого ОП
            for (const userIndex in usersIDs) {
              const userRate = this.users.filter(
                (e) => e.ID == usersIDs[userIndex]
              )[0].rate;
              const comissionAgency =
                comissionAgencyData == "base"
                  ? userRate
                    ? Number(userRate) + 0.1
                    : 0.7
                  : comissionAgencyData;
              //расчет сумм
              let sum = 0;
              sum = Number(price) * Number(countItems[userIndex]);
              const ridPercnt =
                comissionAgency != 0
                  ? comissionAgency != 1
                    ? comissionAgency != 0.024
                      ? 0.05
                      : 0
                    : 0
                  : 0;

              const rewardAutor = Number(sum * ridPercnt);
              const rewardUser = Number(
                sum * (1 - Number(Number(comissionAgency) + Number(ridPercnt)))
              );
              const total = rewardAutor + rewardUser;
              const comission = 0;
              const totalInPay = total - comission;

              console.log({ sum });
              console.log({ ridPercnt });
              console.log({ comissionAgency });
              console.log(
                1 - Number(Number(comissionAgency) + Number(ridPercnt))
              );

              const item = {
                id: `${usersIDs[userIndex]}/${elem.ID}`,
                check: elem.PROPERTY_484 ? true : false,
                number: elem.ID,
                hours: countItems[userIndex],
                name: this.users.filter((e) => e.ID == usersIDs[userIndex])[0]
                  .NAME,
                period: period,
                managerID: usersIDs[userIndex],
                deal: dealData.data.result.TITLE,
                dealID: dealData.data.result.ID,
                product: propertyValue(elem.PROPERTY_462),
                sumToDeal,
                sumToDealXls: new Intl.NumberFormat("ru-RU").format(
                  Number(sumToDeal.toFixed(2))
                ),
                rid: this.ridType[propertyValue(elem.PROPERTY_288)],
                sum: new Intl.NumberFormat("ru-RU").format(sum.toFixed(2)),
                sumXls: sum,
                date: elem.PROPERTY_348 ? propertyValue(elem.PROPERTY_348) : "",
                dateReport: elem.PROPERTY_368
                  ? propertyValue(elem.PROPERTY_368)
                  : "",
                comment: elem.PROPERTY_288
                  ? this.propertyComments[propertyValue(elem.PROPERTY_288)]
                  : "",
                typeAction: typeAction ? this.typeActions[typeAction] : "",
                rewardAutor: new Intl.NumberFormat("ru-RU").format(
                  Number(rewardAutor.toFixed(2))
                ),
                rewardAutorXls: rewardAutor,
                rewardUser: new Intl.NumberFormat("ru-RU").format(
                  Number(rewardUser.toFixed(2))
                ),
                rewardUserXls: rewardUser,
                total: new Intl.NumberFormat("ru-RU").format(total.toFixed(2)),
                totalXls: total,
                comission: new Intl.NumberFormat("ru-RU").format(
                  comission.toFixed(2)
                ),
                comissionXls: comission,
                isComission: this.users.filter(
                  (e) => e.ID == usersIDs[userIndex]
                )[0].isIP
                  ? true
                  : false,
                totalInPay: new Intl.NumberFormat("ru-RU").format(
                  totalInPay.toFixed(2)
                ),
                totalInPayXls: totalInPay,
                action: "",
              };
              console.log({ item });
              items.push(item);
            }
            for (const item of items) {
              let managerPayed = -1;
              const managerPayedIndex = this.paysList.findIndex(
                (e) => e.manager == item.managerID
              );
              if (managerPayedIndex > -1) {
                managerPayed = this.paysList[managerPayedIndex].pays.findIndex(
                  (e) => e == item.number
                );
              }

              if (managerPayed < 0) {
                this.items.push(item);
              }
            }
          } else {
            console.log("не попадает в отчет!");
          }
        } else {
          const typeSalary = propertyValue(elem.PROPERTY_464);
          if (typeSalary == "808" && !hasManager) {
            //ручной
            const price = sumToDeal; //итого сумма
            //перебираем каждого ОП
            for (const userIndex in usersIDs) {
              const sum = Number(price);
              const total = sum;
              const comission = 0;
              const totalInPay = total - comission;

              const item = {
                id: `${usersIDs[userIndex]}/${elem.ID}`,
                check: elem.PROPERTY_484 ? true : false,
                number: elem.ID,
                hours: "",
                name: this.users.filter((e) => e.ID == usersIDs[userIndex])[0]
                  .NAME,
                period: period,
                managerID: usersIDs[userIndex],
                deal: "",
                dealID: "",
                product: propertyValue(elem.PROPERTY_462),
                sumToDeal,
                rid: "Презентация",
                sum: new Intl.NumberFormat("ru-RU").format(sum.toFixed(2)),
                sumXls: sum,
                date: elem.PROPERTY_348 ? propertyValue(elem.PROPERTY_348) : "",
                dateReport: elem.PROPERTY_368
                  ? propertyValue(elem.PROPERTY_368)
                  : "",
                comment: elem.PROPERTY_288
                  ? this.propertyComments[propertyValue(elem.PROPERTY_288)]
                  : "",
                typeAction: typeAction ? this.typeActions[typeAction] : "",
                rewardUser: new Intl.NumberFormat("ru-RU").format(
                  (Number(sum) * 0.95).toFixed(2)
                ),
                rewardUserXls: Number(sum) * 0.95,
                rewardAutor: new Intl.NumberFormat("ru-RU").format(
                  (Number(sum) * 0.05).toFixed(2)
                ),
                rewardAutorXls: Number(sum) * 0.05,
                total: new Intl.NumberFormat("ru-RU").format(total.toFixed(2)),
                totalXls: total,
                comission: new Intl.NumberFormat("ru-RU").format(
                  comission.toFixed(2)
                ),
                comissionXls: comission,
                isComission: this.users.filter(
                  (e) => e.ID == usersIDs[userIndex]
                )[0].isIP
                  ? true
                  : false,
                totalInPay: new Intl.NumberFormat("ru-RU").format(
                  totalInPay.toFixed(2)
                ),
                totalInPayXls: totalInPay,
                action: "",
              };
              const items = [item];
              for (const item of items) {
                let managerPayed = -1;
                const managerPayedIndex = this.paysList.findIndex(
                  (e) => e.manager == item.managerID
                );
                if (managerPayedIndex > -1) {
                  managerPayed = this.paysList[
                    managerPayedIndex
                  ].pays.findIndex((e) => e == item.number);
                }

                if (managerPayed < 0) {
                  this.items.push(item);
                }
              }
            }
          } else if (typeSalary == "842" && !hasManager) {
            //расчет по коэффициенту
            console.log("интернет-магазин!");
            const price = sumToDeal; //итого сумма
            //PROPERTY_290 - коэфф каждого ОП
            const countItems = elem.PROPERTY_290
              ? Object.values(elem.PROPERTY_290)
              : "";

            //let sumToOP = 0;
            //перебираем каждого ОП
            for (const userIndex in usersIDs) {
              const userRate = this.users.filter(
                (e) => e.ID == usersIDs[userIndex]
              )[0].rate;
              const comissionAgency =
                comissionAgencyData == "base"
                  ? userRate
                    ? Number(userRate) + 0.1
                    : 0.7
                  : comissionAgencyData;
              //расчет сумм
              let sum = 0;
              sum = Number(price) * Number(countItems[userIndex]);

              const ridPercnt =
                comissionAgency != 0
                  ? comissionAgency != 1
                    ? comissionAgency != 0.024
                      ? 0.05
                      : 0
                    : 0
                  : 0;
              const rewardAutor = Number(sum * ridPercnt);
              const rewardUser = Number(
                sum * (1 - (Number(comissionAgency) + Number(ridPercnt)))
              );
              const total = rewardAutor + rewardUser;
              const comission = 0;
              const totalInPay = total - comission;

              const item = {
                id: `${usersIDs[userIndex]}/${elem.ID}`,
                check: elem.PROPERTY_484 ? true : false,
                number: elem.ID,
                hours: countItems[userIndex],
                name: this.users.filter((e) => e.ID == usersIDs[userIndex])[0]
                  .NAME,
                period: period,
                managerID: usersIDs[userIndex],
                deal: "",
                dealID: "",
                product: propertyValue(elem.PROPERTY_462),
                sumToDeal,
                sumToDealXls: new Intl.NumberFormat("ru-RU").format(
                  Number(sumToDeal.toFixed(2))
                ),
                rid: this.ridType[propertyValue(elem.PROPERTY_288)],
                sum: new Intl.NumberFormat("ru-RU").format(sum.toFixed(2)),
                sumXls: sum,
                date: elem.PROPERTY_348 ? propertyValue(elem.PROPERTY_348) : "",
                dateReport: elem.PROPERTY_368
                  ? propertyValue(elem.PROPERTY_368)
                  : "",
                comment: elem.PROPERTY_288
                  ? this.propertyComments[propertyValue(elem.PROPERTY_288)]
                  : "",
                typeAction: typeAction ? this.typeActions[typeAction] : "",
                rewardAutor: new Intl.NumberFormat("ru-RU").format(
                  Number(rewardAutor.toFixed(2))
                ),
                rewardAutorXls: rewardAutor,
                rewardUser: new Intl.NumberFormat("ru-RU").format(
                  Number(rewardUser.toFixed(2))
                ),
                rewardUserXls: rewardUser,
                total: new Intl.NumberFormat("ru-RU").format(total.toFixed(2)),
                totalXls: total,
                comission: new Intl.NumberFormat("ru-RU").format(
                  comission.toFixed(2)
                ),
                comissionXls: comission,
                isComission: this.users.filter(
                  (e) => e.ID == usersIDs[userIndex]
                )[0].isIP
                  ? true
                  : false,
                totalInPay: new Intl.NumberFormat("ru-RU").format(
                  totalInPay.toFixed(2)
                ),
                totalInPayXls: totalInPay,
                action: "",
              };
              items.push(item);
            }
            for (const item of items) {
              let managerPayed = -1;
              const managerPayedIndex = this.paysList.findIndex(
                (e) => e.manager == item.managerID
              );
              if (managerPayedIndex > -1) {
                managerPayed = this.paysList[managerPayedIndex].pays.findIndex(
                  (e) => e == item.number
                );
              }

              if (managerPayed < 0) {
                this.items.push(item);
              }
            }
          }
        }
      }

      console.log(this.isAdmin, "is admin");
      if (this.isAdmin) {
        if (this.selectUser) {
          this.reportItems = this.items.filter(
            (e) => e.managerID == this.selectUser
          );
        } else {
          this.reportItems = this.items;
        }
      } else {
        this.reportItems = this.items.filter((e) => e.managerID == this.userID);
      }

      for (const manager of this.users) {
        const items = this.reportItems.filter((e) => e.managerID == manager.ID);
        if (items.length > 0) {
          !items[0].isComission
            ? (this.totalPays += Math.round(
                Number(
                  items.reduce(function (acc, item) {
                    return Number(acc) + Number(item.totalXls);
                  }, 0)
                )
              ))
            : (this.totalPays += Math.round(
                Number(
                  items.reduce(function (acc, item) {
                    return Number(acc) + Number(item.totalXls);
                  }, 0)
                ).toFixed(2)
              ));
        }
      }
      this.loadingValue = 100;
    },
    async exportXls(items) {
      //PROPERTY_452 отчет по оплатам
      this.payLoading = true;
      const workbook = new exeljs.Workbook();
      workbook.views = [
        {
          x: 0,
          y: 0,
          width: 14,
          height: 100,
          visibility: "visible",
        },
      ];
      const worksheet = workbook.addWorksheet("Отчет");
      worksheet.columns = [
        { header: "", key: "number", width: 5 }, //№
        { header: "", key: "period", width: 20 }, //Дата действия
        { header: "", key: "date", width: 15 }, //Отчетный период
        { header: "", key: "comment", width: 15 }, //Что было сделано
        {
          header: "", //Сумма выручки за проведенные консультации
          key: "sum",
          width: 17,
        },
        {
          header: "", //Вознаграждение Исполнителя за Услуги по Договору
          key: "rewardUser",
          width: 17,
        },
        {
          header: "", //Наименование РИД, созданное Исполнителем по Договору
          key: "rid",
          width: 30,
        },
        {
          header: "", //Авторское вознаграждение Исполнителя за РИД
          key: "rewardAutor",
          width: 17,
        },
        { header: "", key: "dateReport", width: 15 }, //Дата отчета
        { header: "", key: "name", width: 25 }, //ФИО Исполнителя
        { header: "", key: "total", width: 15 }, //ИТОГО
        {
          header: "", //Комиссия за перевод с ИП физ.лицу 1% + 59руб.
          key: "comission",
          width: 15,
        },
        { header: "", key: "totalInPay", width: 15 }, //ИТОГО к оплате:
      ];
      //первая строка
      worksheet.addRow(["ОТЧЕТ"]);
      worksheet.mergeCells("A2", "K2");
      worksheet.getRow(2).alignment = {
        vertical: "middle",
        horizontal: "center",
        // wrapText: true,
      };
      //2 строка
      worksheet.addRow({
        number: "Заказчик:",
        date: "Индивидуальный предприниматель Абрамова Татьяна Сергеевна",
      });
      worksheet.mergeCells("A3", "B3");
      worksheet.mergeCells("C3", "G3");

      worksheet.addRow({
        number: "Исполнитель:",
        date: items[0].name + ", плательщик НПД",
      });
      worksheet.mergeCells("A4", "B4");
      worksheet.mergeCells("C4", "G4");
      worksheet.mergeCells("H4", "I4");
      //строка 5
      const product =
        "Консультационные услуги по направлениям: организация пространства жилых и нежилых, планирование мебели, закупка материалов, переезд; внесение информации в клиентскую базу; осуществление фотографирования, видеосъёмки и предоставления фото-видео материалов, иные услуги";

      worksheet.addRow({
        number: "Наименованеие услуги:",
        date: product,
      });
      worksheet.mergeCells("A5", "B5");
      worksheet.mergeCells("C5", "I5");
      worksheet.getRow(5).alignment = {
        vertical: "middle",
        horizontal: "left",
        wrapText: true,
      };
      worksheet.addRow();
      worksheet.addRow();
      //строка 8
      worksheet.addRow({
        number: "№",
        period: "Отчетный период",
        date: "Дата действия",
        comment: "Услуга",
        sum: "Сумма выручки за проведенные консультации",
        rewardUser: "Вознаграждение Исполнителя за Услуги по Договору",
        rid: "Наименование РИД, созданное Исполнителем по Договору",
        rewardAutor: "Авторское вознаграждение Исполнителя за РИД",
        dateReport: "Дата отчета",
        name: "ФИО Исполнителя",
        total: "ИТОГО",
        comission: "Комиссия за перевод с ИП физ.лицу 1% + 59руб.",
        totalInPay: "ИТОГО к оплате",
      });
      worksheet.getRow(8).alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      worksheet.getCell("K8").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "DCDCDC" },
      };
      worksheet.getCell("K8").value = {
        richText: [
          {
            font: {
              bold: true,
              size: 12,
              color: { theme: 1 },
              name: "Times New Roman",
              family: 2,
              scheme: "minor",
            },
            text: "ИТОГО",
          },
        ],
      };
      worksheet.getCell("M8").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE4E1" },
      };
      worksheet.getCell("M8").value = {
        richText: [
          {
            font: {
              bold: true,
              size: 12,
              color: { theme: 1 },
              name: "Times New Roman",
              family: 2,
              scheme: "minor",
            },
            text: "ИТОГО к оплате",
          },
        ],
      };

      let indexRow = 8;
      let totalXls = 0;
      for (const item of items) {
        indexRow += 1;
        totalXls += item.totalXls;
        worksheet.addRow({
          number: item.number,
          period: item.period,
          date: item.date,
          comment: item.comment,
          sum: item.sum,
          rewardUser: item.rewardUser,
          rid: item.rid,
          rewardAutor: item.rewardAutor,
          dateReport: item.dateReport,
          name: item.name,
          total: item.total,
          comission: "-",
          totalInPay: "-",
        });
        worksheet.getRow(indexRow).alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
        worksheet.getCell("K" + indexRow).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "DCDCDC" },
        };
        worksheet.getCell("K" + indexRow).value = {
          richText: [
            {
              font: {
                bold: true,
                size: 12,
                color: { theme: 1 },
                name: "Times New Roman",
                family: 2,
                scheme: "minor",
              },
              text: item.total,
            },
          ],
        };
        worksheet.getCell("M" + indexRow).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE4E1" },
        };
        worksheet.getCell("M" + indexRow).value = {
          richText: [
            {
              font: {
                bold: true,
                size: 12,
                color: { theme: 1 },
                name: "Times New Roman",
                family: 2,
                scheme: "minor",
              },
              text: "-",
            },
          ],
        };
      }
      let comissionXls = 0; //!items[0].isComission ? totalXls * 0.01 + 59 : 0;
      let totalInPayXls = totalXls - comissionXls;

      //форматирование итогов
      const total = new Intl.NumberFormat("ru-RU").format(totalXls);
      const comission = new Intl.NumberFormat("ru-RU").format(comissionXls);
      const totalInPay = new Intl.NumberFormat("ru-RU").format(
        Math.round(totalInPayXls)
      );

      worksheet.addRow({
        number: "ИТОГО:",
        total: total,
        comission: !items[0].isComission ? comission : "-",
        totalInPay: totalInPay,
      });
      worksheet.mergeCells("A" + (indexRow + 1), "J" + (indexRow + 1));
      worksheet.getRow(indexRow + 1).alignment = {
        vertical: "middle",
        horizontal: "center",
      };
      worksheet.getCell("A" + (indexRow + 1)).alignment = {
        vertical: "middle",
        horizontal: "right",
      };
      worksheet.getCell("A" + (indexRow + 1)).value = {
        richText: [
          {
            font: {
              bold: true,
              size: 12,
              color: { theme: 1 },
              name: "Times New Roman",
              family: 2,
              scheme: "minor",
            },
            text: "ИТОГО",
          },
        ],
      };
      worksheet.getCell("A" + (indexRow + 1)).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE4E1" },
      };
      worksheet.getCell("K" + (indexRow + 1)).value = {
        richText: [
          {
            font: {
              bold: true,
              size: 12,
              color: { theme: 1 },
              name: "Times New Roman",
              family: 2,
              scheme: "minor",
            },
            text: total,
          },
        ],
      };
      worksheet.getCell("K" + (indexRow + 1)).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE4E1" },
      };
      worksheet.getCell("L" + (indexRow + 1)).value = {
        richText: [
          {
            font: {
              bold: true,
              size: 12,
              color: { theme: 1 },
              name: "Times New Roman",
              family: 2,
              scheme: "minor",
            },
            text: !items[0].isComission ? comission : "-",
          },
        ],
      };
      worksheet.getCell("L" + (indexRow + 1)).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE4E1" },
      };
      worksheet.getCell("M" + (indexRow + 1)).value = {
        richText: [
          {
            font: {
              bold: true,
              size: 12,
              color: { theme: 1 },
              name: "Times New Roman",
              family: 2,
              scheme: "minor",
            },
            text: totalInPay,
          },
        ],
      };
      worksheet.getCell("M" + (indexRow + 1)).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE4E1" },
      };
      const today = new Date();
      const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
      const pastDaysOfYear = (today - firstDayOfYear) / 86400000;
      const week = Math.ceil(
        (pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7
      );
      const year = today.getFullYear();
      //скачивание файла
      const buffer = await workbook.xlsx.writeBuffer();
      for (const item of items) {
        //отметка отчет выгружен
        item.check = true;
        await axios.post(this.url + "bizproc.workflow.start", {
          TEMPLATE_ID: 308,
          DOCUMENT_ID: [
            "lists",
            "Bitrix\\Lists\\BizprocDocumentLists",
            item.number,
          ],
          PARAMETERS: {
            isTrue: "Y",
          },
        });
      }
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const blob = new Blob([buffer], { type: fileType });
      fileWrite(blob, `${week}-${year}_${items[0].name}`);
      this.payLoading = false;
    },
    async normalizeDate() {
      try {
        this.normalDate = [];
        const firstDate = this.dates[0].split("-");
        const twoDate = this.dates[1].split("-");
        const firstDateFormated =
          firstDate[2] + "." + firstDate[1] + "." + firstDate[0] + " 00:00:00";
        const twoDateFormated =
          twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
        this.normalDate.push(firstDateFormated);
        this.normalDate.push(
          firstDate[2] + "." + firstDate[1] + "." + firstDate[0]
        );
        this.normalDate.push(twoDateFormated);
        this.normalDate.push(twoDate[2] + "." + twoDate[1] + "." + twoDate[0]);
      } catch (e) {
        console.log(e);
      }
    },
    async getFields() {
      try {
        this.typeActions = {};
        this.propertyComments = {};

        const propertyTypeActions = await axios.post(
          this.url + "lists.field.get",
          {
            IBLOCK_TYPE_ID: "lists",
            IBLOCK_ID: 36,
            FIELD_ID: "PROPERTY_356",
          }
        );
        this.typeActions =
          propertyTypeActions.data.result.L.DISPLAY_VALUES_FORM;
        const propertyComments = await axios.post(
          this.url + "lists.field.get",
          {
            IBLOCK_TYPE_ID: "lists",
            IBLOCK_ID: 36,
            FIELD_ID: "PROPERTY_288",
          }
        );
        this.propertyComments =
          propertyComments.data.result.L.DISPLAY_VALUES_FORM;
      } catch (e) {
        console.log(e);
      }
    },
    async getUsers() {
      this.users = [];
      let isTrue = false;
      let start = 0;
      while (!isTrue) {
        const users = await axios.post(this.url + "user.get", { start });
        for (const user of users.data.result) {
          this.users.push({
            ID: user.ID,
            NAME: `${user.LAST_NAME} ${user.NAME}`,
            isIP: user.UF_USR_1709112781401
              ? user.UF_USR_1709112781401 == "2332" ||
                user.UF_USR_1709112781401 == "2334"
                ? true
                : false
              : false,
            rate: user.UF_USR_1716565228526,
          });
        }
        if (users.data.next) start = users.data.next;
        else isTrue = true;
      }
    },
    async getDeals() {
      try {
        this.deals = [];
        const dealData = await axios.post(this.url + "crm.deal.list", {
          select: ["TITLE", "ID"],
          filter: { CATEGORY_ID: "0" },
        });
        const batchParams = {
          halt: 0,
          cmd: {},
        };
        let index = 0;
        for (let start = 0; start <= Number(dealData.data.total); start += 50) {
          batchParams.cmd[
            index
          ] = `crm.deal.list?select[0]=TITLE&select[1]=ID&filter[CATEGORY_ID]=0&start=${start}`;
          if (index % 50 == 0 || start + 50 >= dealData.data.total) {
            const batchRes = await axios.post(this.url + "batch", batchParams);
            for (const dealsIndex in batchRes.data.result.result) {
              this.deals.push(...batchRes.data.result.result[dealsIndex]);
            }
            batchParams.cmd = {};
          }
          index += 1;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  async mounted() {
    this.loading = true;
    const bx24 = new BX24();
    const auth = await bx24.getAuth();
    const url = `https://${auth.DOMAIN}/rest/`;
    const user = await axios.post(url + "profile", {
      auth: auth.ACCESS_TOKEN,
    });
    this.userID = user.data.result.ID;
    console.log(this.userID, "userID");
    if (
      user.data.result.ADMIN ||
      user.data.result.ID == 50 ||
      user.data.result.ID == 82 ||
      user.data.result.ID == 96
    ) {
      if (
        user.data.result.ID == 50 ||
        user.data.result.ID == 2 ||
        user.data.result.ID == 82 ||
        user.data.result.ID == 96
      ) {
        this.isPayUser = true;
      }
      this.isAdmin = true;
    } else {
      this.auth = auth;
      this.authUrl = url;
      this.isAdmin = false;
      this.isPayUser = false;
    }
    console.log(this.isAdmin, "userID");

    this.isAdmin = true;
    this.isPayUser = true;

    this.loadingValue = 10;
    await this.getUsers();
    await this.getDeals();
    await this.getFields();
    this.loadingValue = 30;
    await this.getReport();
    this.loadingValue = 100;
    this.loading = false;
  },
};
</script>
